import React, { useEffect, useState } from "react";
import { Topbar } from "@components";
import {
  RootContainer,
  RefreshIcon,
  Top,
  LightText,
  Text,
  Box,
  ActionsWrapper,
  Divider,
  ActionButton,
  Label,
  Title,
  TitleWrapper,
  LinkText,
  Container,
  ListWrapper,
  ListItem,
  ItemText,
  DateText,
  AmountText,
  StatusText,
  Wrapper,
  Image,
  BottomImage,
  Bottom,
  EmptyBox,
  LogoImage,
  ImageWrapper,
  SpinWrapper,
} from "./Wallet.style";
import { useNavigate } from "react-router-dom";
import { PUBLIC_ROUTE, PRIVATE_ROUTE } from "@router/route.constants";
import { Button, Space, Spin } from "antd";
import {
  TopUpFilled,
  WithdrawFilled,
  BalanceLoading,
} from "@assets";
import { TOPUP_LK, WITHDRAW_SK, BONUS_SK } from "@constants";
import { useDispatch, useSelector } from "react-redux";
import { getFormattedNumber, localStorage } from "@utils";
import { FileTextOutlined, ContainerOutlined } from "@ant-design/icons";
import { api } from "@api";
import moment from "moment";
import { saveUser } from "@redux/auth/authSlice";
import { useTranslation } from "react-i18next";
import { getStatus } from "@utils";
import Lottie from "react-lottie";

const dateFormat = "MMM DD, YYYY hh:mm:ss A";

export const BonusImage = () => (
  <ImageWrapper>
    <LogoImage />
  </ImageWrapper>
);

const Wallet = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { main_balance, bonus, is_in_game } = useSelector((state) => state.auth.user);
  const ads = useSelector((state) => state.app.settings.app_carousel)[0];
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);

  useEffect(() => {
    getRecentHistory();

    // eslint-disable-next-line
  }, []);

  const getRecentHistory = () => {
    setLoading(true);
    api
      .getRecentHistory()
      .then(({ transactions, user }) => {
        setLoading(false);
        setData(transactions);

        // Save user to redux
        dispatch(saveUser(user));
        // Set user to localstorage
        localStorage.setUser(user);
      })
      .catch((error) => { });
  };

  const goToHome = () => {
    navigate(`/${PUBLIC_ROUTE.HOME}`);
  };

  const goToTransactions = () => {
    navigate(`/${PRIVATE_ROUTE.TRANSACTIONS}`);
  };

  const goToBonusHistory = () => {
    navigate(`/${PRIVATE_ROUTE.BONUS_HISTORY}`);
  };

  const handleTopUpClicked = () => {
    navigate(`/${PRIVATE_ROUTE.ACCOUNT_TYPE}/${TOPUP_LK}`);
  };

  const handleWithdrawClicked = () => {
    navigate(`/${PRIVATE_ROUTE.WITHDRAW_ACCOUNTS}`);
  };

  const refresh = () => {
    window.location.reload();
  };

  const EmptyCard = () => (
    <EmptyBox>
      <ContainerOutlined />
      <div>{t("common.noRecord")}</div>
    </EmptyBox>
  );

  const renderTop = () => (
    <Top>
      <LightText>{t("wallet.walletTotalBalance")}</LightText>
      <Space>
        <Text>
          {is_in_game
            ? <Lottie
              options={{
                animationData: BalanceLoading,
              }}
              height={20}
            />
            : `${getFormattedNumber(main_balance + bonus)} Ks`
          }
        </Text>
        <Button
          danger
          shape="circle"
          icon={<FileTextOutlined />}
          onClick={goToBonusHistory}
        />
      </Space>
    </Top>
  );

  const Actions = () => (
    <ActionsWrapper>
      <Box>
        <ActionButton onClick={handleTopUpClicked}>
          <TopUpFilled />
          <Label>{t("wallet.walletTopUp")}</Label>
        </ActionButton>
        <Divider />
        <ActionButton onClick={handleWithdrawClicked}>
          <WithdrawFilled />
          <Label>{t("wallet.walletWithdraw")}</Label>
        </ActionButton>
      </Box>
    </ActionsWrapper>
  );

  const Loader = () => (
    <SpinWrapper>
      <Spin />
    </SpinWrapper>
  );

  const List = () => (
    <Container>
      <TitleWrapper>
        <Title>{t("wallet.walletRecentHistory")}</Title>
        <LinkText onClick={goToTransactions}>
          {t("wallet.walletSeeAll")}
        </LinkText>
      </TitleWrapper>
      <ListWrapper>
        {data.map((item, key) => (
          <ListItem key={key}>
            {item.type === BONUS_SK ? (
              <BonusImage />
            ) : (
              <Image
                src={item.payment_category_image}
                radius={
                  item.payment_category_name === "KBZ" ? "none" : "circle"
                }
              />
            )}
            <Wrapper>
              <ItemText>
                {item.type === BONUS_SK
                  ? t("wallet.transactionHistoryBonusType", {
                    bonus_type: item.bonus_type.replaceAll('-bonus', ''),
                  })
                  : `${item.type === WITHDRAW_SK
                    ? t("wallet.walletWithdraw")
                    : t("wallet.walletTopUp")
                  } ${t("common.to")} ${item.num}`}
              </ItemText>
              <DateText>
                {moment.unix(item.created_at).format(dateFormat)}
              </DateText>
              {item.trx_num &&
                <DateText>
                  {`PIN: ${item.trx_num}`}
                </DateText>
              }
            </Wrapper>
            <Wrapper>
              <AmountText>{`${getFormattedNumber(
                item.amount
              )} MMK`}</AmountText>
              {item.type !== BONUS_SK && (
                <StatusText status={item.status}>
                  {getStatus(item.status)}
                </StatusText>
              )}
            </Wrapper>
          </ListItem>
        ))}
        {!loading && data.length === 0 && <EmptyCard />}
        {loading && <Loader />}
      </ListWrapper>
    </Container>
  );

  const renderBottom = () => (
    <Bottom>
      <BottomImage
        src={ads?.image}
        onClick={() => window.open(ads?.url, "_blank")}
      />
    </Bottom>
  );

  return (
    <RootContainer>
      <Topbar
        title={t("wallet.walletTitle")}
        transparent={true}
        rightIcon={<RefreshIcon onClick={refresh} />}
        goBack={goToHome}
      />
      {renderTop()}
      <Actions />
      <List />
      {renderBottom()}
    </RootContainer>
  );
};

export default Wallet;
